export const ShadowClasses = {
    SHADOW_NONE: ['wf-shadow-none'],
    SHADOW_SM: ['wf-shadow-sm'],
    SHADOW_MD: ['wf-shadow-md'],
    SHADOW_LG: ['wf-shadow-lg'],
    SHADOW_XL: ['wf-shadow-xl']
}